import { Component } from '@angular/core';
import { formatISO } from 'date-fns';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';

@Component({
  selector: 'lib-edi-pricat-export-modal',
  templateUrl: './edi-pricat-export-modal.component.html',
  styleUrls: ['./edi-pricat-export-modal.component.css'],
  standalone: false
})
export class EdiPricatExportModalComponent {
  messageId: string = '';

  validFromDate: Date = undefined;
  validToDate: Date = undefined;
  preOrderToDate: Date = undefined;
  sendToFtp: boolean = true;

  delegate: GungModalService;
  componentId: string;

  ngOnInit(): void {
    this.componentId = EdiPricatExportModalComponent.name;
  }

  isValid(): boolean {
    return !!this.validFromDate && !!this.validToDate;
  }

  confirm(): void {
    const result: any = {
      sendToFtp: this.sendToFtp
    };
    if (this.validFromDate) {
      result.pricatValidFromDate = formatISO(this.validFromDate, { representation: 'date' }).replace(/-/g, '');
    }
    if (this.validToDate) {
      result.pricatValidToDate = formatISO(this.validToDate, { representation: 'date' }).replace(/-/g, '');
    }
    if (this.preOrderToDate) {
      result.pricatPreOrderToDate = formatISO(this.preOrderToDate, { representation: 'date' }).replace(/-/g, '');
    }
    this.delegate.modalRef.get(this.componentId).close(result);
  }

  cancel(): void {
    this.delegate.modalRef.get(this.componentId).close(null);
  }
}
